<div class="table-row" [class.selected-row]="isChecked" [attr.data-test]="'table-row-' + index">
  <div class="actions-cell" (click)="check.emit(user)" *ngIf="canRemoveUser">
    <input
      type="checkbox"
      class="checkbox-input"
      [attr.data-test]="'checkbox-' + index"
      [ngModel]="isChecked"
    />
  </div>
  <div class="user-email-status">
    <span
      [class]="statusClass"
      [ngbPopover]="statusPopoverMessage"
      popoverClass="label-popover"
      placement="right"
      triggers="mouseenter:mouseleave"
      container="body"
      >{{ label }}</span
    >
  </div>
  <div class="user-actions" *ngIf="canRemoveUser">
    <div
      [disablePopover]="throttleRemainingTime < 1"
      [ngbPopover]="buttonPopoverMessage"
      popoverClass="label-popover"
      placement="right"
      triggers="mouseenter:mouseleave"
      container="body"
    >
      <button
        [disabled]="throttleRemainingTime > 0"
        *ngIf="!isEmailBounced"
        class="resend-invite-button button-regular cc-btn-subtle-gray"
        (click)="resendInvite()"
      >
        <i class="cc-icon cc-icon-send"></i>
        <span class="sm-text-sm sm-text-black" i18n>Resend Invite</span>
      </button>
      <button
        [disabled]="throttleRemainingTime > 0"
        *ngIf="isEmailBounced"
        class="try-again-button button-regular cc-btn-subtle-gray"
        (click)="removeEmailSuppression()"
      >
        <i class="cc-icon cc-icon-redo" aria-hidden="true"></i>
        <span class="sm-text-sm sm-text-black" i18n>Try again</span>
      </button>
    </div>
  </div>
  <div class="user-email">
    <span [innerHTML]="user?.fullName | textEmphasis: searchTerm:'bold'"> </span>
  </div>
  <div class="permission-toggle sm-pr-2" *ngIf="showPermissionToggle">
    <cc-user-permission-toggle
      [user]="user"
      [permissionOptions]="permissionOptions"
      [canUpdateUserPermission]="canUpdateUserPermission"
      (onUpdatePermission)="onUpdatePermission.emit()"
    ></cc-user-permission-toggle>
  </div>
</div>
